module.exports = __webpack_public_path__ + "img/cover-default.9c6af581.gif";